import { IGetAllReservationsRequest, IGetAvailableAppointmentsRequest, IGetReservationByRequest, ISearchReservationsRequest } from "../../../types";

const API_PREFIX = "/reservations";
export const getGetAllReservationsEndpoint = (getAllReservationsQueries: IGetAllReservationsRequest) => {
  const conditions = getAllReservationsQueries.conditions;

  const queryString = `${API_PREFIX}?from=${conditions?.from}&to=${conditions?.to}`;
  return queryString;
};

export const getSearchReservationsEndpoint = (params: ISearchReservationsRequest) => {
  const searchParams = new URLSearchParams();
  searchParams.set('search', params.search);
  if (params.conditions) {
    searchParams.set('conditions', params.conditions);
  }
  if (params.page !== undefined) {
    searchParams.set('page', String(params.page));
  }
  if (params.pageSize !== undefined) {
    searchParams.set('pageSize', String(params.pageSize));
  }
  return `${API_PREFIX}?${searchParams.toString()}`;
};

export const getGetReservationByEndpoint = (getReservationBy: IGetReservationByRequest) =>
  `${API_PREFIX}/getBy?prop=${getReservationBy.prop}&value=${getReservationBy.value}`;
export const getGetAvailableAppointmentsEndpoint = (getAvailableAppointmentsQueries: IGetAvailableAppointmentsRequest) =>
  `${API_PREFIX}/getAvailableAppointments?source=CMS`;
export const getCreateReservationEndpoint = () => `${API_PREFIX}`;

export const getCreateRecurringReservationEndpoint = () => `${API_PREFIX}/recurring`;

export const editReservationEndpoint = (id: string) => `${API_PREFIX}/${id}`;

export const changeEmployeeEndpoint = (id: string) => `${API_PREFIX}/${id}/change-employee`;

export const cancelChainEndpoint = (id: string) => `${API_PREFIX}/${id}/cancel-chain`;

export const getCancelInfoEndpoint = (id: string) => `${API_PREFIX}/${id}/cancel-info`;

export const getNoShowInfoEndpoint = (id: string) => `${API_PREFIX}/${id}/no-show-info`;
